module.exports = __webpack_public_path__ + "static/img/par13.8009461.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flow/par_game/par13.png
// module id = Z6St
// module chunks = 0